export default __webpack_public_path__ + "static/media/flash.4eec389d.png";